import React, { useState, useEffect } from 'react';
import {
  Alert,
  Backdrop,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  // DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid } from '@mui/x-data-grid';
import SubCard from 'ui-component/cards/SubCard';
import { IoMdArrowBack } from 'react-icons/io';
import { useLocation, useNavigate } from 'react-router';
import { InvoiceStatementList, VendorInvoiceList } from 'API/VendorOnboarding/api';

const InvoiceDetails = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  console.log('location', location);
  const InvoiceDetail = location?.state?.type;
  const [Data, setData] = useState({ date_from: new Date().toISOString().split('T')[0], date_to: new Date().toISOString().split('T')[0] });
  const [ViewStatement, setViewStatement] = useState(false);
  const [VendorList, setVendorList] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [Error, setError] = useState(null);
  const [VendorId, setVendorId] = useState(null);
  const [page, setPage] = useState(0); // Current page (starts from 0)
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [TotalCount, setTotalCount] = useState(0);
  const [InvoiceStatement, setInvoiceStatement] = useState([]);
  const handleChange = (name, value) => {
    setData({ ...Data, [name]: value });
  };
  const NumberonlyInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^0-9a-zA-Z//-]/g, '');
  };
  const handleView = (data) => {
    setViewStatement(true);
    setVendorId(data.vendor_id);
  };
  function formatDateTime(dateString) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    return `${formattedDate}`;
  }
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState([]);

  const handleOpenDialog = (devices) => {
    console.log('device', devices);

    setSelectedDevices(devices);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedDevices([]);
  };
  const columns = [
    { field: 'po_referncee_no', headerName: 'PO No.', width: 150 },
    { field: 'invoice_no', headerName: 'Invoice No', width: 150 },
    { field: 'invoice_date', headerName: 'Invoice Date', width: 120 },
    {
      field: 'device',
      headerName: 'Device',
      width: 100,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          sx={{
            borderColor: '#688B2A',
            color: '#688B2A',
            borderRadius: '6px',
            '&:hover': {
              borderColor: '#688B2A'
            }
          }}
          onClick={() => handleOpenDialog(params.row.device)}
        >
          View
        </Button>
      )
    },
    // { field: 'quantity', headerName: 'Total Quantity', width: 150 },
    // { field: 'recieved', headerName: 'Total Received', width: 150 },
    { field: 'outstand', headerName: 'Quantity Outstanding', width: 150 },
    { field: 'total_amount', headerName: 'Payment Amount', width: 150 },
    { field: 'oamount', headerName: 'Outstanding Amount', width: 150 },
    { field: 'amount', headerName: 'Sales Price', width: 120 },
    { field: 'status', headerName: 'Status', width: 150, renderCell: () => <Chip size="small" label="Pending" /> },
    {
      field: 'action',
      headerName: 'Statement',
      width: 100,
      renderCell: (params) => {
        return (
          <Button
            sx={{
              borderColor: '#688B2A',
              color: '#688B2A',
              borderRadius: '6px',
              '&:hover': {
                borderColor: '#688B2A'
              }
            }}
            onClick={() => handleView(params.row)}
          >
            view
          </Button>
        );
      }
    }
  ];
  const columnStatement = [
    { field: 'date', headerName: 'Date', width: 120 },
    { field: 'transaction', headerName: 'Transaction', width: 150 },
    { field: 'details', headerName: 'Details', width: 350 },
    { field: 'amount', headerName: 'Amount', width: 150 },
    { field: 'payment', headerName: 'Payments', width: 150 },
    { field: 'balance', headerName: 'Balance', width: 150 }
  ];
  const rowStatement =
    InvoiceStatement && Array.isArray(InvoiceStatement)
      ? InvoiceStatement.map((item, index) => ({
          _id: index,
          date: item.date ? formatDateTime(item.date) : '-',
          transaction: item.transaction ? item.transaction : '-',
          details: item.details ? item.details : '-',
          amount: item.amount ? `₹${item.amount.toLocaleString(`en-IN`)}` : '-',
          payment: item.payment ? `₹${item.payment}` : '-',
          balance: item.balance ? `₹${item.balance}` : '-'
        }))
      : [];
  const rows =
    VendorList && Array.isArray(VendorList)
      ? VendorList.map((item) => ({
          _id: item._id,
          po_referncee_no: item.po_referncee_no ? item.po_referncee_no : '-',
          invoice_no: item.invoice_no ? item.invoice_no : '-',
          invoice_date: item.invoice_date ? formatDateTime(item.invoice_date) : '-',
          device: item?.devices ? item?.devices : '-',
          quantity: item.devices[0].device_name ? item.devices[0].device_name : '-',
          recieved: item.devices[0].device_name ? item.devices[0].device_name : '-',
          vendor_id: item.vendor_id ? item.vendor_id : '-',
          outstand: item.total_amount ? item.total_amount : '-',
          total_amount: item.total_amount ? item.total_amount : '-',
          oamount: item.total_amount ? item.total_amount : '-',
          amount: item.total_amount ? item.total_amount : '-',
          status: item.vendor ? item.vendor : '-'
        }))
      : [];
  const column = ViewStatement ? columnStatement : columns;
  const row = ViewStatement ? rowStatement : rows;
  const handleClear = () => {
    setData({
      date_from: new Date().toISOString().split('T')[0],
      date_to: new Date().toISOString().split('T')[0],
      // device_name: 'select',
      po_no: ''
    });
  };

  useEffect(() => {
    if (!ViewStatement) {
      // setVendorList([])
      VendorInvoiceList(page + 1, rowsPerPage, Data, setVendorList, setIsLoading, setError, setTotalCount);
    }
  }, [!ViewStatement, Data, page, rowsPerPage]);

  useEffect(() => {
    if (ViewStatement) {
      setInvoiceStatement([]);
      InvoiceStatementList(page + 1, rowsPerPage, Data, VendorId, setInvoiceStatement, setIsLoading, setError, setTotalCount);
    }
  }, [ViewStatement, Data.date_from, Data.date_to, page, rowsPerPage]);

  return (
    <>
      {/* device list */}
      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
        <DialogTitle variant="h3">Device Details</DialogTitle>
        <IconButton aria-label="close" onClick={handleCloseDialog} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {selectedDevices?.length > 0 ? (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="device table">
                <TableHead>
                  <TableRow>
                    <TableCell>Device Name</TableCell>
                    <TableCell>Model No</TableCell>
                    <TableCell>Total Quantity</TableCell>
                    <TableCell>Total Received</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedDevices.map((device, index) => (
                    <TableRow key={index}>
                      <TableCell>{device.device_name || '-'}</TableCell>
                      <TableCell>{device.model_no || '-'}</TableCell>
                      <TableCell>{device.quantity_order || '-'}</TableCell>
                      <TableCell>{device.quantity_received || '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography mt={2}>No devices found.</Typography>
          )}
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions> */}
      </Dialog>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={IsLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Error}
        autoHideDuration={5000}
        onClose={() => setError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setError(false)} variant="filled" severity="error" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <SubCard title={!ViewStatement ? 'Invoice Details' : 'Vendor statement'}>
        <Button
          sx={{ width: '20px' }}
          variant="outlined"
          size="small"
          color="info"
          onClick={() => {
            if (ViewStatement) {
              setViewStatement(false);
            } else {
              Navigate(-1);
            }
          }}
        >
          <IoMdArrowBack style={{ fontSize: '20px' }} />
        </Button>
        <Grid container spacing={1} mb={2} mt={1}>
          {ViewStatement ? (
            <Grid item xl={2.5} lg={2.5} md={3} sm={3} xs={4} ml={1}>
              {/* <Typography sx={{ color: '#20415C' }} variant="h5">
                Vendor statement
              </Typography> */}
              <Typography sx={{ color: '#20415C' }} variant="h5" mt={2}>
                Vendor name : <span style={{ color: '#364152' }}>{InvoiceDetail?.vendor_name || '-'}</span>
              </Typography>
              <Typography sx={{ color: '#20415C' }} variant="h5">
                Vendor code : <span style={{ color: '#364152' }}>{InvoiceDetail?.vendor_code || '-'}</span>
              </Typography>
            </Grid>
          ) : null}
          <Grid item xl={2} lg={2} md={3} sm={3} xs={4}>
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              From Date
            </Typography>
            <TextField
              id="outlined-basic"
              size="small"
              // label="From Date"
              fullWidth
              value={Data.date_from ? Data.date_from : ''}
              variant="outlined"
              type="date"
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                max: new Date().toISOString().split('T')[0],
                onKeyDown: (e) => e.preventDefault()
              }}
              onChange={(e) => handleChange('date_from', e.target.value)}
            />
          </Grid>
          <Grid item xl={2} lg={2} md={3} sm={3} xs={4}>
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              To Date
            </Typography>
            <TextField
              id="outlined-basic"
              // label="To Date"
              size="small"
              fullWidth
              value={Data.date_to ? Data.date_to : ''}
              variant="outlined"
              inputProps={{
                min: Data.date_from,
                max: new Date().toISOString().split('T')[0],
                onKeyDown: (e) => e.preventDefault()
              }}
              type="date"
              InputLabelProps={{
                shrink: true
              }}
              onChange={(e) => handleChange('date_to', e.target.value)}
            />
          </Grid>
          {ViewStatement ? null : (
            <Grid item xl={2} lg={2} md={3} sm={4} xs={4} sx={{ display: 'none' }}>
              <FormControl fullWidth>
                {/* <InputLabel id="demo-simple-select-label">Vendor</InputLabel> */}
                <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                  Vendor
                </Typography>
                <Select
                  labelid="demo-simple-select-label"
                  size="small"
                  id="demo-simple-select"
                  // label="Vendor"
                  value={Data.device_name ? Data.device_name : 'select'}
                  onChange={(e) => handleChange('device_name', e.target.value)}
                >
                  <MenuItem value={'select'} disabled>
                    Select
                  </MenuItem>

                  <MenuItem>demo</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          {ViewStatement ? null : (
            <Grid item xl={2} lg={2} md={3} sm={4} xs={4}>
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                Po No
              </Typography>
              <TextField
                id="outlined-basic"
                size="small"
                // label="PO No"
                fullWidth
                value={Data.po_no ? Data.po_no : ''}
                onInput={NumberonlyInput}
                variant="outlined"
                onChange={(e) => handleChange('po_no', e.target.value)}
              />
            </Grid>
          )}
          <Grid item xl={2} lg={4} md={2} sm={2} xs={4} display={'flex'} alignItems={'center'} mt={3}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleClear}
              // disabled={Object.keys(Data).length === 0}
              size="small"
              sx={{
                backgroundColor: '#592375',
                color: '#FFFFFF',
                borderRadius: '6px',
                '&:hover': {
                  backgroundColor: '#592375'
                }
              }}
            >
              clear
            </Button>
          </Grid>
        </Grid>
        {/* <VendorStepForm /> */}
        <DataGrid
          columns={column}
          rows={row}
          getRowId={(row) => row._id}
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              color: '#592375'
            }
          }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
                page: 0
              }
            }
          }}
          pageSizeOptions={[10, 50, 100]} // Allow user to choose from these options
          rowCount={TotalCount}
          paginationMode="server"
          onPaginationModelChange={(paginationModel) => {
            setPage(paginationModel.page); // Update the current page
            setRowsPerPage(paginationModel.pageSize); // Update the rows per page
          }}
          autoHeight
          disableRowSelectionOnClick
        />
      </SubCard>
    </>
  );
};

export default InvoiceDetails;
